<template>
  <div class="account-container"
       :style="{ height: `calc(100vh - ${headerHeight - 53 + 4}px)` }">
    <div class="account">
      <div class="account-wrap">
        <h1>
          <i class="icon logo--seeall"
               title="seeall"></i>
        </h1>
        <h2>Sign In</h2>
        <p class="input-wrap">
          <label for="userId">ID</label>
          <input type="text"
                 name="userId"
                 id="userId"
                 v-model.trim="model.email"
                 placeholder="Email"
                 @keyup.enter="onPreSignIn" />
          <strong class="wrong"
                  v-if="errors.email">{{ $t(errors.email) }}</strong>
        </p>
        <p class="input-wrap">
          <label for="userPW">Password</label>
          <input type="password"
                 name="userPW"
                 id="userPW"
                 v-model="model.password"
                 ref="password"
                 placeholder="Password"
                 @keyup.enter="onPreSignIn" />
          <strong class="wrong"
                  v-if="errors.password">{{ $t(errors.password) }}</strong>
          <strong class="wrong"
                  v-if="errors.account">{{ $t(errors.account) }}</strong>
        </p>

        <div class="btns">
          <button type="button"
                  class="btn_1"
                  @click="onSignIn">Sign In</button>
        </div>
        <p class="more">
          <router-link :to="{ name: 'SignUp' }">Register</router-link>
          <span class="line"></span>
          <router-link :to="{ name: 'RecoverPassword' }">Forgot password</router-link>
        </p>
      </div>
      <address class="copyright">
        Copyright © {{ (new Date()).getFullYear() }} 4Grit. All rights reserved.
      </address>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import authApi from '../../api/auth'
import ajaxHandlerMixin from '@/mixins/ajax-handler'

export default {
  name: 'SignIn',
  mixins: [ajaxHandlerMixin],
  data () {
    return {
      errors: {},
      model: {
        email: null,
        password: null
      },
      showDialog: false,
      dialogData: null
    }
  },
  computed: {
    ...mapState(['headerHeight'])
  },
  methods: {
    ...mapMutations(['setUserData']),
    onPreSignIn () {
      if (this.model.email && this.model.password) {
        this.onSignIn()
      }
    },
    onSignIn () {
      authApi.signIn(this.model).then(response => {
        const data = response.data

        if (!data) {
          throw new Error('signIn failed')
        }
        this.setUserData(data)

        switch (data.statusCode) {
          case 1:
            this.$router.replace({ name: 'Main' })
            return
          default:
            this.$router.replace({ name: 'AccountStatus' })
        }
      }).catch(err => {
        this.handleAjaxError(err)

        if (this.errors.password || this.errors.account) {
          this.model.password = null
          this.$refs.password.focus()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.account-container {
  position: relative;
  width: calc(100% - 2px);
  min-height: 600px;
  background: url('../../../src/assets/asset--sign-in.jpg');
  background-size: cover;
  background-position: center center;
  padding: 1px;
}

.account {
  width: 340px;
  height: calc(100% - 12px);
  border-radius: 14px;
  box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  margin: 6px;
  position: relative;

  .account-wrap {
    position: absolute;
    top: 39.5%;
    left: 0;
    transform: translateY(-50%);
    width: 100%;

    h1 {
      margin: 0 39px;

      .logo--seeall {
        height: 30px;
        width: 101px;
      }
    }

    h2 {
      margin: 10px 39px;
      font-size: 50px;
      font-weight: bold;
      color: #555555;
    }

    .input-wrap {
      margin: 0 39px;
      height: 85px;

      label {
        font-size: 12px;
        padding: 0 5px;
        font-weight: bold;
        line-height: 1;
        color: #767676;
      }

      input {
        width: 100%;
      }

      .wrong {
        margin-left: 5px;
        font-size: 12px;
        font-weight: normal;
        color: #ec0047;
        white-space: nowrap;
      }
    }

    .btns {
      margin: 8px 39px 15px;

      button {
        width: 100%;
      }
    }

    .more {
      margin: 0 39px;
      text-align: center;

      a {
        font-size: 13px;
        line-height: 1.46;
        color: #666666;
      }

      .line {
        display: inline-block;
        width: 1px;
        height: 12px;
        background-color: #d7d7d7;
        vertical-align: middle;
        margin: 0 8px 0 5px;
      }
    }
  }

  .copyright {
    position: absolute;
    bottom: 28px;
    left: 0;
    width: 100%;
    font-size: 11px;
    font-style: normal;
    color: #666666;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/guest/SignIn.vue